import React from 'react'
import { Icon } from '~/types'
import { icons } from '~/utils'

export const Hashtag: React.FunctionComponent<Icon.Props> = ({ mode = 'light' }) => {
  const color = icons.getIconColor(mode)

  return (
    <svg width="12px" height="12px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke={color}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
    </svg>
  )
}

export default Hashtag
